import React, { useState } from 'react';
import ThemeControls from "../../Component/AllThemesControl";
import Switch from '@mui/material/Switch';
import { APIGET, APIPATCH } from '../../services/APIServices';
import Loader from "../../images/impulse/gif.gif"
const jsonSample={
  "Parameter": {
      "page_label": "",
      "fields": [
          {
              "field_id": "Name",
          }
      ]
  },
  "xioFEConfig": {
      "TabStyle": "cardStyle",
      "actionName": "",
      "createLink": "",
      "viewLink": "",
      "createButtonText": "",
      "viewButtonText": "",
      "paragraphText": "",
      "sideImageData": {
          "img_heading": "",
          "img_paragraph": ""
      }
  }
}

const PermissionsComponent = () => {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [permissions, setPermissions] = useState();
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [color, setColor] = useState('');
 
  async function settingData(apiPath) {
    return await APIGET(apiPath).then(data => {
      try {
        if (data) {
          setPermissions(data?.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    })
  }

  React.useEffect(() => {
    // settingData( 'rolePermissions/all');
    settingData(`rolePermissions/filter?roleId=10910`);
  }, [])

  // const [selectedRole, setSelectedRole] = useState(10910);

  function handleSuccessMsgUpdate(data) {
    if (data.dataRecevied.statusCode === "SUCCESS" || data.dataRecevied.statusCode === "Success") {
      // alert('Successfully Updated')
      setColor('Successfully Updated')
    }
  }
  function handleError(msg) {
    setColor(msg)
  }

  async function updateData(data) {
    //console.log(path)
    try {
      const response = await APIPATCH('rolePermissions/' + data.id, data, jsonSample, handleSuccessMsgUpdate, handleError);
      if (response) {
        response.then((responseData) => {
        })
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  const updatePermissions = (id, field, value) => {
    const updatedPermissions = permissions.map(permission => {
      if (permission.id === id) {
        const data={ ...permission, [field]: value }
        console.log(data)
        updateData(data)
        return { ...permission, [field]: value };
      }
      return permission;
    });

    setPermissions(updatedPermissions);
  };

  const handleRoleChange = (event) => {
    setLoading(true);
    settingData(`rolePermissions/filter?roleId=${parseInt(event.target.value)}`);
    // setSelectedRole(parseInt(event.target.value));
  };

  // const filteredPermissions = permissions?.filter(permission => permission?.roleId === selectedRole);

  return (
    <div className='main'>
        <div>
          <label htmlFor="role-select">Select Role: </label>
          <select id="role-select" onChange={handleRoleChange}>
            <option value="10910">Sales Role</option>
            <option value="10499">MM Role</option>
            <option value="10498">Finance Role</option>
            <option value="10497">Noc Role</option>
            <option value="10915">Operational Role</option>
          </select>
          <p style={{ fontSize: '18px', color: 'green' }}>{color}</p>
          {loading ? <div style={{ padding: '20px', display: 'flex', justifyContent: 'center' }}>
            <div style={{ overflow: 'hidden', position: 'relative', height: '500px', width: "500px" }}>
              <img src={Loader} alt="loading..." style={{ height: '100%', width: '100%', objectPosition: 'center', objectFit: 'cover' }} />
            </div>
          </div> : 
          <div className={classes.table}>
            <table >
              <thead>
                <tr>
                  <th>Application Context</th>
                  <th>Role</th>
                  <th>Authorize</th>
                  <th>Delete</th>
                  <th>List</th>
                  <th>Save</th>
                  <th>Updates</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                {permissions.map(permission => (
                  <tr key={permission.id}>
                    <td>{permission.applicationcontext}</td>
                    <td>{permission.roleId}</td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.authorizeP === 1}
                        disabled={permission.accessPersmission !== 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'authorizeP', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.deleteP === 1}
                        disabled={permission.accessPersmission !== 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'deleteP', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.listP === 1}
                        disabled={permission.accessPersmission !== 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'listP', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.saveP === 1}
                        disabled={permission.accessPersmission !== 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'saveP', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.updatesP === 1}
                        disabled={permission.accessPersmission !== 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'updatesP', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                    <td>
                      <Switch
                        className='switch'
                        checked={permission.accessPersmission === 1}
                        onChange={e =>
                          updatePermissions(permission.id, 'accessPersmission', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          }
        </div>
    </div>
  );
};

export default PermissionsComponent;
